import httpRequest from "@/service/index";

/**
 * @description get new leads
 * @return {Promise}
 */
const BASE_URL: any = process.env.NUXT_PUBLIC_AUTH_BASE;



// export const api_submit_application = (data: any) => {
//     return request({
//         baseUrl: import.meta.env.VITE_API_NUXT_PUBLIC_AUTH_BASE,
//         url: "/submit_application",
//         method: "post",
//         headers: get_headers(),
//         data,
//     });
// }

const submitApplication = (data: any) => {
    return httpRequest.post(BASE_URL, "/submit_application", data).then((res: any) => {
        console.log(res);
        const data = res.data._value || res.data._rawValue || res.data.value;
        if (data === undefined || data === null || data === "") {
            return Promise.reject(res.error.value.data);
        } else {
            return Promise.resolve(data);
        }

    }).catch((err: any) => {
        return Promise.reject(err);
    });
}

const sendMagicLink = (data: any) => {
    return httpRequest.post(BASE_URL, "/send_magic_link", data).then((res: any) => {
        console.log(res);
        const data = res.data._value || res.data._rawValue || res.data.value;
        if (data === undefined || data === null || data === "") {
            return Promise.reject(res.error.value.data);
        } else {
            return Promise.resolve(data);
        }

    }).catch((err: any) => {
        return Promise.reject(err);
    });
}

export { submitApplication, sendMagicLink }
